import { render, staticRenderFns } from "./TopPrice.vue?vue&type=template&id=08e80a1c&scoped=true&"
import script from "./TopPrice.vue?vue&type=script&lang=js&"
export * from "./TopPrice.vue?vue&type=script&lang=js&"
import style0 from "./TopPrice.vue?vue&type=style&index=0&id=08e80a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e80a1c",
  null
  
)

export default component.exports